module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-2-Article.8040d226.webp";